import { Center } from '@chakra-ui/react'
import Lottie, { type LottieRefCurrentProps } from 'lottie-react'
import { useEffect, useRef } from 'react'
import animationData from '../assets/load_in_2.json'
import useWindowHeight from '../hooks/useWindowHeight'

const Loading2 = () => {
  const windowHeight = useWindowHeight()
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  useEffect(() => {
    lottieRef.current?.setSpeed(2)
  }, [])

  return (
    <Center w="100vw" h={`${windowHeight}px`} bg="secondary.400">
      <Center flexDirection="column">
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop={false}
          autoplay
          rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
          style={{ height: 160, width: 460 }}
        />
      </Center>
    </Center>
  )
}

export default Loading2
